"use server";

import { redirect } from "next/navigation";
import { verifyAdminPassword } from "@/lib/auth/password";
import { clearSessionCookie, setSessionCookie } from "@/lib/auth/session";

export async function loginAction(input: { password: string; next?: string }) {
  if (!verifyAdminPassword(input.password)) {
    return { ok: false as const, message: "Passwort falsch." };
  }
  await setSessionCookie();
  redirect(input.next?.startsWith("/") ? input.next : "/");
}

export async function logoutAction() {
  await clearSessionCookie();
  redirect("/login");
}
